module.exports = __webpack_public_path__ + "static/mask_lo_125-bb996167d971bc2980fb050224e6a30f.jpg";